// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1wgEP","choiceBoxes":"toolbarselects_choiceBoxes__26j3l","simpleField":"toolbarselects_simpleField__ia-xe"};